import Layout from '@/layout'

const reportRouter = {
  path: '/report',
  component: Layout,
  redirect: 'report/director_report',
  name: 'Nested',
  meta: {
    title: 'Báo cáo',
    icon: ''
  },
  children: [
    {
      path: '/report/group_report',
      name: 'Báo cáo đoàn',
      meta: {
        title: 'Báo cáo đoàn',
        icon: ''
      },
      redirect: '/report/group_report/group_guest_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'group_guest_report',
          name: 'Báo cáo khách đoàn',
          meta: {
            title: 'Báo cáo khách đoàn',
            icon: ''
          },
          component: () => import('@/views/mci/report/groupGuestReport.vue')
        },
        {
          path: 'date_cancel_keep_room_report',
          name: 'Báo cáo hủy giữ phòng đoàn',
          meta: {
            title: 'Báo cáo hủy giữ phòng đoàn',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/DateCancelKeepRoomReport.vue')
        },
        {
          path: 'diary_change_group_report',
          name: 'Báo cáo nhật ký thay đổi đoàn',
          meta: {
            title: 'Báo cáo nhật ký thay đổi đoàn',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/DiaryChangeGroupReport.vue')
        }
      ]
    },
    {
      path: '/report/discount_detail',
      name: 'Báo cáo chi tiết giảm giá',
      meta: {
        title: 'Báo cáo chi tiết giảm giá',
        icon: ''
      },
      component: () => import('@/views/mci/report/discountDetail.vue')
    },
    {
      path: '/report/discount_summary',
      name: 'Báo cáo tổng hợp giảm giá',
      meta: {
        title: 'Báo cáo tổng hợp giảm giá',
        icon: ''
      },
      component: () => import('@/views/mci/report/discountSummary.vue')
    },
    {
      path: '/report/it_report',
      name: 'Báo cáo IT',
      meta: {
        title: 'Báo cáo IT',
        icon: ''
      },
      redirect: '/report/it_report/create_smartkey_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'create_smartkey_report',
          name: 'Báo cáo tạo khóa từ',
          meta: {
            title: 'Báo cáo tạo khóa từ',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/creatingSmartKeyReport.vue')
        },
        {
          path: 'card_of_guest_report',
          name: 'Báo cáo sử dụng thẻ của khách',
          meta: {
            title: 'Báo cáo sử dụng thẻ của khách',
            icon: ''
          },
          component: () => import('@/views/mci/report/guestCardReport.vue')
        },
        {
          path: 'card_internal_report',
          name: 'Báo cáo sử dụng thẻ nội bộ',
          meta: {
            title: 'Báo cáo sử dụng thẻ nội bộ',
            icon: ''
          },
          component: () => import('@/views/mci/report/cardInternalReport.vue')
        },
        {
          path: 'diary_change_status_room_report',
          name: 'Báo cáo nhật ký thay đổi trạng thái phòng',
          meta: {
            title: 'Báo cáo nhật ký thay đổi trạng thái phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/roomStatusChangeDiaryReport.vue')
        }
      ]
    },
    {
      path: '/report/reception_report',
      name: 'Báo cáo lễ tân',
      meta: {
        title: 'Báo cáo lễ tân'
      },
      redirect: '/report/reception_report/reservation_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'reservation_report',
          name: 'Báo cáo đặt phòng',
          meta: {
            title: 'Báo cáo đặt phòng',
            icon: ''
          },
          component: () => import('@/views/mci/report/reservationReport.vue')
        },
        {
          path: 'arrival_guest_report',
          name: 'Báo cáo khách đến',
          meta: {
            title: 'Báo cáo khách đến',
            icon: ''
          },
          component: () => import('@/views/mci/report/arriveGuestReport.vue')
        },
        {
          path: 'checkout_report',
          name: 'Báo cáo checkout',
          meta: {
            title: 'Báo cáo checkout',
            icon: ''
          },
          component: () => import('@/views/mci/report/checkoutReport.vue')
        },
        {
          path: 'breakfast_report',
          name: 'Báo cáo ăn sáng',
          meta: {
            title: 'Báo cáo ăn sáng',
            icon: ''
          },
          component: () => import('@/views/mci/report/breakfastReport.vue')
        },
        {
          path: 'cancel_guest_report',
          name: 'Báo cáo khách hủy',
          meta: {
            title: 'Báo cáo khách hủy',
            icon: ''
          },
          component: () => import('@/views/mci/report/guestCancelReport.vue')
        },
        {
          path: 'room_status_daily_report',
          name: 'Báo cáo tình trạng phòng và dịch vụ đặc biệt',
          meta: {
            title: 'Báo cáo tình trạng phòng và dịch vụ đặc biệt',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/roomStatusDailyReport.vue')
        },
        {
          path: 'expected_report',
          name: 'Báo cáo dự kiến',
          meta: {
            title: 'Báo cáo dự kiến',
            icon: ''
          },
          component: () => import('@/views/mci/report/expectedReport.vue')
        },
        {
          path: 'depart_guest_report',
          name: 'Báo cáo khách đi',
          meta: {
            title: 'Báo cáo khách đi',
            icon: ''
          },
          component: () => import('@/views/mci/report/guestDepatureReport.vue')
        },
        {
          path: 'living_guest_report',
          name: 'Báo cáo khách đang ở',
          meta: {
            title: 'Báo cáo khách đang ở',
            icon: ''
          },
          component: () => import('@/views/mci/report/livingGuestReport.vue')
        },
        {
          path: 'group_guest_report',
          name: 'Báo cáo khách đoàn',
          meta: {
            title: 'Báo cáo khách đoàn',
            icon: ''
          },
          component: () => import('@/views/mci/report/groupGuestReport.vue')
        },
        {
          path: 'hotel_link_report',
          name: 'Báo cáo đặt phòng OTA',
          meta: {
            title: 'Báo cáo đặt phòng OTA',
            icon: ''
          },
          component: () => import('@/views/mci/report/hotelLinkReport.vue')
        }
      ]
    },
    {
      path: '/report/hk_report',
      name: 'Báo cáo buồng phòng',
      meta: {
        title: 'Báo cáo buồng phòng'
      },
      redirect: '/report/hk_report/hk_check_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'compensation',
          name: 'Báo cáo đền bù',
          meta: {
            title: 'Báo cáo đền bù',
            icon: ''
          },
          component: () => import('@/views/mci/report/compensationReport.vue')
        },
        {
          path: 'hk_check_report',
          name: 'Báo cáo buồng phòng cần kiểm tra',
          meta: {
            title: 'Báo cáo buồng phòng cần kiểm tra',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/houseKeepingMustCheckReport.vue')
        },
        {
          path: 'lost_report',
          name: 'Báo cáo đồ thất lạc',
          meta: {
            title: 'Báo cáo đồ thất lạc',
            icon: ''
          },
          component: () => import('@/views/mci/report/lostPropertyReport.vue')
        },
        {
          path: 'arrival_guest_report',
          name: 'Báo cáo khách đến',
          meta: {
            title: 'Báo cáo khách đến',
            icon: ''
          },
          component: () => import('@/views/mci/report/arriveGuestHKReport.vue')
        },
        {
          path: 'checkout_report',
          name: 'Báo cáo checkout',
          meta: {
            title: 'Báo cáo checkout',
            icon: ''
          },
          component: () => import('@/views/mci/report/checkoutHKReport.vue')
        },
        {
          path: 'room_status_daily_report',
          name: 'Báo cáo tình trạng phòng và dịch vụ đặc biệt',
          meta: {
            title: 'Báo cáo tình trạng phòng và dịch vụ đặc biệt',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/roomStatusDailyReport.vue')
        },

        {
          path: 'depart_guest_report',
          name: 'Báo cáo khách đi',
          meta: {
            title: 'Báo cáo khách đi',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/guestDepatureHKReport.vue')
        },
        {
          path: 'living_guest_report',
          name: 'Báo cáo khách đang ở',
          meta: {
            title: 'Báo cáo khách đang ở',
            icon: ''
          },
          component: () => import('@/views/mci/report/livingGuestReport.vue')
        },
        {
          path: 'equipment_report',
          name: 'Báo cáo trang thiết bị',
          meta: {
            title: 'Báo cáo trang thiết bị',
            icon: ''
          },
          component: () => import('@/views/mci/report/equipmentReport.vue')
        }
      ]
    },
    {
      path: '/report/cfo_report',
      name: 'Báo cáo CFO',
      meta: {
        title: 'Báo cáo CFO'
      },
      redirect: '/report/cfo_report/sales_employee_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'limit_report',
          name: 'Báo cáo hạn mức',
          meta: {
            title: 'Báo cáo hạn mức',
            icon: ''
          },
          component: () => import('@/views/mci/report/limitReport.vue')
        },
        {
          path: 'refund_report',
          name: 'Báo cáo hoàn tiền',
          meta: {
            title: 'Báo cáo hoàn tiền',
            icon: ''
          },
          component: () => import('@/views/mci/report/refundReport.vue')
        },
        {
          path: 'compensation',
          name: 'Báo cáo đền bù',
          meta: {
            title: 'Báo cáo đền bù',
            icon: ''
          },
          component: () => import('@/views/mci/report/compensationReport.vue')
        },
        {
          path: 'sales_employee_report',
          name: 'Báo cáo Nhân viên bán hàng',
          meta: {
            title: 'Báo cáo Nhân viên bán hàng',
            icon: ''
          },
          component: () => import('@/views/mci/report/salesEmployeeReport.vue')
        },
        {
          path: 'revenue_booking_report',
          name: 'Báo cáo doanh thu đặt phòng theo hạng phòng',
          meta: {
            title: 'Báo cáo doanh thu đặt phòng theo hạng phòng',
            icon: ''
          },
          component: () => import('@/views/mci/report/revenueBookingReport.vue')
        },
        {
          path: 'group_guest_report',
          name: 'Báo cáo khách đoàn',
          meta: {
            title: 'Báo cáo khách đoàn',
            icon: ''
          },
          component: () => import('@/views/mci/report/groupGuestReport.vue')
        },
        {
          path: 'revenue_booking_daily_report',
          name: 'Báo cáo doanh thu đặt phòng theo ngày',
          meta: {
            title: 'Báo cáo doanh thu đặt phòng theo ngày',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/revenueBookingDailyReport.vue')
        },
        {
          path: 'free_room_report',
          name: 'Báo cáo chi tiết phòng miễn phí',
          meta: {
            title: 'Báo cáo chi tiết phòng miễn phí',
            icon: ''
          },
          component: () => import('@/views/mci/report/freeRoomReport.vue')
        },
        {
          path: 'discount_booking_report',
          name: 'Báo cáo giảm giá đặt phòng',
          meta: {
            title: 'Báo cáo giảm giá đặt phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/discountBookingReport.vue')
        },
        {
          path: 'daily_transaction_synthesis_report',
          name: 'Báo cáo tổng hợp giao dịch theo ngày',
          meta: {
            title: 'Báo cáo tổng hợp giao dịch theo ngày',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/dailyTransSynthesisReport/index.vue')
        },
        {
          path: 'mini_bar_report',
          name: 'Báo cáo mini bar',
          meta: {
            title: 'Báo cáo mini bar',
            icon: ''
          },
          component: () => import('@/views/mci/report/miniBarReport.vue')
        },
        {
          path: 'equipment_report',
          name: 'Báo cáo trang thiết bị',
          meta: {
            title: 'Báo cáo trang thiết bị',
            icon: ''
          },
          component: () => import('@/views/mci/report/equipmentReport.vue')
        },
        {
          path: 'general_manage_report',
          name: 'Báo cáo quản lí chung',
          meta: {
            title: 'Báo cáo quản lí chung',
            icon: ''
          },
          component: () => import('@/views/mci/report/generalManagement.vue')
        },
        {
          path: 'chart_by_source_group_report',
          name: 'Báo cáo biểu đồ theo nhóm nguồn',
          meta: {
            title: 'Báo cáo biểu đồ theo nhóm nguồn',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/chartBySourceGroupReport.vue')
        },
        {
          path: 'revenue_by_agency_report',
          name: 'Báo cáo doanh thu theo đại lý',
          meta: {
            title: 'Báo cáo doanh thu theo đại lý',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/revenueByAgencyCFOReport.vue')
        },
        {
          path: 'agency_detail_report',
          name: 'Báo cáo chi tiết đại lý',
          meta: {
            title: 'Báo cáo chi tiết đại lý',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/agencyDetailCFOReport.vue')
        },
        {
          path: 'fill_rate_report',
          name: 'Báo cáo tỉ lệ lấp đầy',
          meta: {
            title: 'Báo cáo tỉ lệ lấp đầy',
            icon: ''
          },
          component: () => import('@/views/mci/report/fillRateReport.vue')
        },
        {
          path: 'fill_rate_by_month_report',
          name: 'Báo cáo tỉ lệ lấp đầy theo tháng',
          meta: {
            title: 'Báo cáo tỉ lệ lấp đầy theo tháng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/fillRateByMonthReport.vue')
        },
        {
          path: 'walkins_guest_report',
          name: 'Báo cáo khách Walk-in',
          meta: {
            title: 'Báo cáo khách Walk-in',
            icon: ''
          },
          component: () => import('@/views/mci/report/walkInGuestReport.vue')
        },
        {
          path: 'bonus_transaction_report',
          name: 'Báo cáo chi tiết theo đặt phòng',
          meta: {
            title: 'Báo cáo chi tiết theo đặt phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/incurredTransactionReport.vue')
        },
        {
          path: 'payment_report',
          name: 'Báo cáo thanh toán',
          meta: {
            title: 'Báo cáo thanh toán',
            icon: ''
          },
          component: () => import('@/views/mci/report/paymentReport/index.vue')
        },
        {
          path: 'housekeeper_report',
          name: 'Báo cáo buồng phòng',
          meta: {
            title: 'Báo cáo buồng phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/houseKeepingReport/index.vue')
        },
        {
          path: 'laundry',
          name: 'Báo cáo giặt là',
          meta: {
            title: 'Báo cáo giặt là',
            icon: ''
          },
          component: () => import('@/views/mci/report/laundryReport/index.vue')
        },
        {
          path: 'ooo_report',
          name: 'Báo cáo phòng OOO/OOS',
          meta: {
            title: 'Báo cáo phòng OOO/OOS',
            icon: ''
          },
          component: () => import('@/views/mci/report/oooReport.vue')
        },
        {
          path: 'invoice_adjust_report',
          name: 'Báo cáo điều chỉnh giao dịch',
          meta: {
            title: 'Báo cáo điều chỉnh giao dịch',
            icon: ''
          },
          component: () => import('@/views/mci/report/InvoiceAdjustReport.vue')
        },
        {
          path: 'invoice_cancel_report',
          name: 'Báo cáo hủy hóa đơn',
          meta: {
            title: 'Báo cáo hủy hóa đơn',
            icon: ''
          },
          component: () => import('@/views/mci/report/InvoiceCancelReport.vue')
        },
        {
          path: 'synthetic_transaction_report',
          name: 'Báo cáo hình thức thanh toán theo hóa đơn',
          meta: {
            title: 'Báo cáo hình thức thanh toán theo hóa đơn',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/SyntheticTransactionReport.vue')
        },
        {
          path: 'detail_revenue_booking_report',
          name: 'Báo cáo chi tiết doanh thu đặt phòng và dịch vụ theo nhân viên',
          meta: {
            title:
              'Báo cáo chi tiết doanh thu đặt phòng và dịch vụ theo nhân viên',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/DetailRevenueBookingReport.vue')
        },
        {
          path: 'cash_report',
          name: 'Báo cáo tiền mặt',
          meta: {
            title: 'Báo cáo tiền mặt',
            icon: ''
          },
          component: () => import('@/views/mci/report/CashReport.vue')
        },
        {
          path: 'compare_revenue_booking_report',
          ame: 'Báo cáo đối chiếu doanh thu kế toán',
          meta: {
            title: 'Báo cáo đối chiếu doanh thu kế toán',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/CompareRevenueBookingReport.vue')
        },
        {
          path: 'synthetic_revenue_report',
          name: 'Báo cáo tổng hợp doanh thu phòng',
          meta: {
            title: 'Báo cáo tổng hợp doanh thu phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/SyntheticRevenueReport.vue')
        },
        {
          path: 'detail_revenue_report',
          name: 'Báo cáo doanh thu chi tiết',
          meta: {
            title: 'Báo cáo doanh thu chi tiết',
            icon: ''
          },
          component: () => import('@/views/mci/report/DetailRevenueReport.vue')
        },
        {
          path: 'capacity_chart_report',
          name: 'Báo cáo biểu đồ công suất phòng',
          meta: {
            title: 'Báo cáo biểu đồ công suất phòng',
            icon: ''
          },
          component: () => import('@/views/mci/report/CapacityChartReport.vue')
        },
        {
          path: 'synthetic_debt_report',
          name: 'Báo cáo tổng hợp công nợ',
          meta: {
            title: 'Báo cáo tổng hợp công nợ',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/SyntheticDebtCFOReport.vue')
        },
        {
          path: 'detail_debt_report',
          name: 'Báo cáo chi tiết công nợ',
          meta: {
            title: 'Báo cáo chi tiết công nợ',
            icon: ''
          },
          component: () => import('@/views/mci/report/DetailDebtCFOReport.vue')
        },
        {
          path: 'sales_report',
          component: () => import('@/views/nested/menu1/index'),
          name: 'Báo cáo Sales/Marketting',
          meta: {
            title: 'Báo cáo Sales/Marketting',
            icon: ''
          },
          redirect: '/report/cfo_report/sales_report/voucher',
          children: [
            {
              path: 'voucher',
              name: 'Báo cáo sử dụng voucher',
              meta: {
                title: 'Báo cáo sử dụng voucher'
              },
              component: () =>
                import('@/views/mci/report/salesReport/VoucherReport.vue')
            },
            {
              path: 'promotion',
              name: 'Báo cáo doanh thu theo chương trình',
              meta: {
                title: 'Báo cáo doanh thu theo chương trình'
              },
              component: () =>
                import('@/views/mci/report/salesReport/PromotionReport.vue')
            },
            {
              path: 'advertise',
              name: 'Báo cáo doanh thu từ quảng cáo',
              meta: {
                title: 'Báo cáo doanh thu từ quảng cáo'
              },
              component: () =>
                import('@/views/mci/report/salesReport/AdvertiseReport.vue')
            },
            {
              path: 'event',
              name: 'Báo cáo doanh thu theo sự kiện',
              meta: {
                title: 'Báo cáo doanh thu theo sự kiện'
              },
              component: () =>
                import('@/views/mci/report/salesReport/EventReport.vue')
            }
          ]
        },
        {
          path: 'cancel_guest_report',
          name: 'Báo cáo khách hủy',
          meta: {
            title: 'Báo cáo khách hủy',
            icon: ''
          },
          component: () => import('@/views/mci/report/guestCancelReport.vue')
        },
        {
          path: 'breakfast_report',
          name: 'Báo cáo ăn sáng',
          meta: {
            title: 'Báo cáo ăn sáng',
            icon: ''
          },
          component: () => import('@/views/mci/report/breakfastReport.vue')
        },
        {
          path: 'stay_combo_report',
          name: 'Báo cáo combo lưu trú',
          meta: {
            title: 'Báo cáo combo lưu trú',
            icon: ''
          },
          component: () => import('@/views/mci/report/stayCombo.vue')
        }
      ]
    },

    {
      path: '/report/accounting_report',
      name: 'Báo cáo kế toán',
      meta: {
        title: 'Báo cáo kế toán'
      },
      redirect: '/report/accounting_report/take_money_by_invoice_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'refund_report',
          name: 'Báo cáo hoàn tiền',
          meta: {
            title: 'Báo cáo hoàn tiền',
            icon: ''
          },
          component: () => import('@/views/mci/report/refundReport.vue')
        },
        {
          path: 'take_money_by_invoice_report',
          name: 'Báo cáo thu tiền theo hóa đơn',
          meta: {
            title: 'Báo cáo thu tiền theo hóa đơn',
            icon: ''
          },
          component: () => import('@/views/mci/report/takeMoneybyInvoice.vue')
        },
        {
          path: 'cancel_transaction_report',
          ame: 'Báo cáo hủy giao dịch',
          meta: {
            title: 'Báo cáo hủy giao dịch',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/cancelTransactionReport.vue')
        },
        {
          path: 'deposit_daily_report',
          name: 'Báo cáo đặt cọc theo ngày',
          meta: {
            title: 'Báo cáo đặt cọc theo ngày',
            icon: ''
          },
          component: () => import('@/views/mci/report/depositDailyReport.vue')
        },
        {
          path: 'discount_booking_report',
          name: 'Báo cáo giảm giá đặt phòng',
          meta: {
            title: 'Báo cáo giảm giá đặt phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/discountBookingReport.vue')
        },
        {
          path: 'breakfast_report',
          name: 'Báo cáo ăn sáng',
          meta: {
            title: 'Báo cáo ăn sáng',
            icon: ''
          },
          component: () => import('@/views/mci/report/breakfastReport.vue')
        },
        {
          path: 'free_room_report',
          name: 'Báo cáo chi tiết phòng miễn phí',
          meta: {
            title: 'Báo cáo chi tiết phòng miễn phí',
            icon: ''
          },
          component: () => import('@/views/mci/report/freeRoomReport.vue')
        },
        {
          path: 'daily_transaction_synthesis_report',
          name: 'Báo cáo tổng hợp giao dịch theo ngày',
          meta: {
            title: 'Báo cáo tổng hợp giao dịch theo ngày',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/dailyTransSynthesisReport/index.vue')
        },
        {
          path: 'mini_bar_report',
          name: 'Báo cáo mini bar',
          meta: {
            title: 'Báo cáo mini bar',
            icon: ''
          },
          component: () => import('@/views/mci/report/miniBarReport.vue')
        },
        {
          path: 'bonus_transaction_report',
          name: 'Báo cáo chi tiết theo đặt phòng',
          meta: {
            title: 'Báo cáo chi tiết theo đặt phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/incurredTransactionReport.vue')
        },
        {
          path: 'payment_report',
          name: 'Báo cáo thanh toán',
          meta: {
            title: 'Báo cáo thanh toán',
            icon: ''
          },
          component: () => import('@/views/mci/report/paymentReport/index.vue')
        },
        {
          path: 'invoice_cancel_report',
          name: 'Báo cáo hủy hóa đơn',
          meta: {
            title: 'Báo cáo hủy hóa đơn',
            icon: ''
          },
          component: () => import('@/views/mci/report/InvoiceCancelReport.vue')
        },
        {
          path: 'synthetic_transaction_report',
          name: 'Báo cáo hình thức thanh toán theo hóa đơn',
          meta: {
            title: 'Báo cáo hình thức thanh toán theo hóa đơn',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/SyntheticTransactionReport.vue')
        },
        {
          path: 'cash_report',
          name: 'Báo cáo tiền mặt',
          meta: {
            title: 'Báo cáo tiền mặt',
            icon: ''
          },
          component: () => import('@/views/mci/report/CashReport.vue')
        },
        {
          path: 'limit_report',
          name: 'Báo cáo hạn mức',
          meta: {
            title: 'Báo cáo hạn mức',
            icon: ''
          },
          component: () => import('@/views/mci/report/limitReport.vue')
        },
        {
          path: 'invoice_adjust_report',
          name: 'Báo cáo điều chỉnh giao dịch',
          meta: {
            title: 'Báo cáo điều chỉnh giao dịch',
            icon: ''
          },
          component: () => import('@/views/mci/report/InvoiceAdjustReport.vue')
        },
        {
          path: 'synthetic_debt_report',
          name: 'Báo cáo tổng hợp công nợ',
          meta: {
            title: 'Báo cáo tổng hợp công nợ',
            icon: ''
          },
          component: () => import('@/views/mci/report/SyntheticDebtReport.vue')
        },
        {
          path: 'detail_debt_report',
          name: 'Báo cáo chi tiết công nợ',
          meta: {
            title: 'Báo cáo chi tiết công nợ',
            icon: ''
          },
          component: () => import('@/views/mci/report/DetailDebtReport.vue')
        },
        {
          path: 'invoice_report',
          name: 'Báo cáo hóa đơn',
          meta: {
            title: 'Báo cáo hóa đơn',
            icon: ''
          },
          component: () => import('@/views/mci/report/InvoiceReport.vue')
        },
        {
          path: 'compensation',
          name: 'Báo cáo đền bù',
          meta: {
            title: 'Báo cáo đền bù',
            icon: ''
          },
          component: () => import('@/views/mci/report/compensationReport.vue')
        },
        {
          path: 'stay_combo_report',
          name: 'Báo cáo combo lưu trú',
          meta: {
            title: 'Báo cáo combo lưu trú',
            icon: ''
          },
          component: () => import('@/views/mci/report/stayCombo.vue')
        }
      ]
    },
    {
      path: '/report/director_report',
      name: 'Báo cáo Giám đốc',
      meta: {
        title: 'Báo cáo Giám đốc'
      },
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'room_report',
          name: 'Báo cáo phòng',
          meta: {
            title: 'Báo cáo phòng',
            icon: ''
          },
          component: () => import('@/views/nested/menu1/index'),
          redirect:
            '/report/director_report/room_report/revenue_booking_weeky_report',

          children: [
            {
              path: 'revenue_booking_weeky_report',
              name: 'Báo cáo dự báo đặt phòng theo tuần',
              meta: {
                title: 'Báo cáo dự báo đặt phòng theo tuần',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/revenueBookingWeekyReport.vue')
            },
            {
              path: 'history_forecast_by_roomlevel_report',
              name: 'Báo cáo lịch sử dự báo theo hạng phòng',
              meta: {
                title: 'Báo cáo lịch sử dự báo theo hạng phòng',
                icon: ''
              },
              component: () =>
                import(
                  '@/views/mci/report/historyForecastbyRoomLevelReport.vue'
                )
            },
            {
              path: 'history',
              name: 'Báo cáo lịch sử',
              meta: {
                title: 'Báo cáo lịch sử'
              },
              component: () =>
                import('@/views/mci/report/historyReport/historyReport.vue')
            },
            {
              path: 'forecast',
              name: 'Báo cáo dự báo',
              meta: {
                title: 'Báo cáo dự báo'
              },
              component: () =>
                import('@/views/mci/report/historyReport/foreCastReport.vue')
            },
            {
              path: 'daily_report',
              name: 'Báo cáo hoạt động hàng ngày',
              meta: {
                title: 'Báo cáo hoạt động hàng ngày',
                icon: ''
              },
              component: () => import('@/views/mci/report/dailyReport.vue')
            },
            {
              path: 'revenue_booking_report',
              name: 'Báo cáo doanh thu đặt phòng theo hạng phòng',
              meta: {
                title: 'Báo cáo doanh thu đặt phòng theo hạng phòng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/revenueBookingReport.vue')
            },
            {
              path: 'revenue_booking_daily_report',
              name: 'Báo cáo doanh thu đặt phòng theo ngày',
              meta: {
                title: 'Báo cáo doanh thu đặt phòng theo ngày',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/revenueBookingDailyReport.vue')
            },
            {
              path: 'discount_booking_report',
              name: 'Báo cáo giảm giá đặt phòng',
              meta: {
                title: 'Báo cáo giảm giá đặt phòng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/discountBookingReport.vue')
            },
            {
              path: 'equipment_report',
              name: 'Báo cáo trang thiết bị',
              meta: {
                title: 'Báo cáo trang thiết bị',
                icon: ''
              },
              component: () => import('@/views/mci/report/equipmentReport.vue')
            },
            {
              path: 'general_manage_report',
              name: 'Báo cáo quản lí chung',
              meta: {
                title: 'Báo cáo quản lí chung',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/generalManagement.vue')
            },
            {
              path: 'fill_rate_by_month_report',
              name: 'Báo cáo tỉ lệ lấp đầy theo tháng',
              meta: {
                title: 'Báo cáo tỉ lệ lấp đầy theo tháng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/fillRateByMonthReport.vue')
            },
            {
              path: 'synthetic_free_room_report',
              name: 'Báo cáo tổng hợp miễn phí',
              meta: {
                title: 'Báo cáo tổng hợp miễn phí',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/syntheticFreeRoomReport.vue')
            },
            {
              path: 'walkins_guest_report',
              name: 'Báo cáo khách Walk-in',
              meta: {
                title: 'Báo cáo khách Walk-in',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/walkInGuestReport.vue')
            },
            {
              path: 'synthetic_transaction_report',
              name: 'Báo cáo hình thức thanh toán theo hóa đơn',
              meta: {
                title: 'Báo cáo hình thức thanh toán theo hóa đơn',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/SyntheticTransactionReport.vue')
            },
            {
              path: 'synthetic_revenue_report',
              name: 'Báo cáo tổng hợp doanh thu phòng',
              meta: {
                title: 'Báo cáo tổng hợp doanh thu phòng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/SyntheticRevenueReport.vue')
            },
            {
              path: 'detail_revenue_report',
              name: 'Báo cáo doanh thu chi tiết',
              meta: {
                title: 'Báo cáo doanh thu chi tiết',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/DetailRevenueReport.vue')
            },
            {
              path: 'fill_rate_report',
              name: 'Báo cáo tỉ lệ lấp đầy',
              meta: {
                title: 'Báo cáo tỉ lệ lấp đầy',
                icon: ''
              },
              component: () => import('@/views/mci/report/fillRateReport.vue')
            },
            {
              path: 'stay_combo_report',
              name: 'Báo cáo combo lưu trú',
              meta: {
                title: 'Báo cáo combo lưu trú',
                icon: ''
              },
              component: () => import('@/views/mci/report/stayCombo.vue')
            }
          ]
        },
        {
          path: 'house_keep_report',
          name: 'Báo cáo buồng',
          meta: {
            title: 'Báo cáo buồng',
            icon: ''
          },
          component: () => import('@/views/nested/menu1/index'),
          redirect:
            '/report/director_report/house_keep_report/housekeeper_report',
          children: [
            {
              path: 'housekeeper_report',
              name: 'Báo cáo buồng phòng',
              meta: {
                title: 'Báo cáo buồng phòng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/houseKeepingReport/index.vue')
            },
            {
              path: 'laundry',
              name: 'Báo cáo giặt là',
              meta: {
                title: 'Báo cáo giặt là',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/laundryReport/index.vue')
            },
            {
              path: 'ooo_report',
              name: 'Báo cáo phòng OOO/OOS',
              meta: {
                title: 'Báo cáo phòng OOO/OOS',
                icon: ''
              },
              component: () => import('@/views/mci/report/oooReport.vue')
            },
            {
              path: 'lost_report',
              name: 'Báo cáo đồ thất lạc',
              meta: {
                title: 'Báo cáo đồ thất lạc',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/lostPropertyReport.vue')
            }
          ]
        },
        {
          path: 'analysis_report',
          name: 'Báo cáo phân tích',
          meta: {
            title: 'Báo cáo phân tích',
            icon: ''
          },
          component: () => import('@/views/nested/menu1/index'),
          redirect:
            '/report/director_report/analysis_report/sales_employee_report',
          children: [
            {
              path: 'sales_employee_report',
              name: 'Báo cáo Nhân viên bán hàng',
              meta: {
                title: 'Báo cáo Nhân viên bán hàng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/salesEmployeeReport.vue')
            },
            // {
            //   path: 'compare_revenue_room_report',
            //   name: 'Báo cáo tổng hợp giao dịch buồng phòng',
            //   meta: {
            //     title: 'Báo cáo tổng hợp giao dịch buồng phòng',
            //     icon: ''
            //   },
            //   component: () =>
            //     import(
            //       '@/views/mci/report/housekeepingTransSynthesisReport.vue'
            //     )
            // },
            {
              path: 'chart_by_source_group_report',
              name: 'Báo cáo biểu đồ theo nhóm nguồn',
              meta: {
                title: 'Báo cáo biểu đồ theo nhóm nguồn',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/chartBySourceGroupReport.vue')
            },
            {
              path: 'revenue_by_agency_report',
              name: 'Báo cáo doanh thu theo đại lý',
              meta: {
                title: 'Báo cáo doanh thu theo đại lý',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/revenueByAgencyReport.vue')
            },
            {
              path: 'agency_detail_report',
              name: 'Báo cáo chi tiết đại lý',
              meta: {
                title: 'Báo cáo chi tiết đại lý',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/agencyDetailReport.vue')
            },
            {
              path: 'capacity_chart_report',
              name: 'Báo cáo biểu đồ công suất phòng',
              meta: {
                title: 'Báo cáo biểu đồ công suất phòng',
                icon: ''
              },
              component: () =>
                import('@/views/mci/report/CapacityChartReport.vue')
            },
            {
              path: 'voucher',
              name: 'Báo cáo sử dụng voucher',
              meta: {
                title: 'Báo cáo sử dụng voucher'
              },
              component: () =>
                import('@/views/mci/report/salesReport/VoucherReport.vue')
            },
            {
              path: 'promotion',
              name: 'Báo cáo doanh thu theo chương trình',
              meta: {
                title: 'Báo cáo doanh thu theo chương trình'
              },
              component: () =>
                import('@/views/mci/report/salesReport/PromotionReport.vue')
            },
            {
              path: 'advertise',
              name: 'Báo cáo doanh thu từ quảng cáo',
              meta: {
                title: 'Báo cáo doanh thu từ quảng cáo'
              },
              component: () =>
                import('@/views/mci/report/salesReport/AdvertiseReport.vue')
            },
            {
              path: 'event',
              name: 'Báo cáo doanh thu theo sự kiện',
              meta: {
                title: 'Báo cáo doanh thu theo sự kiện'
              },
              component: () =>
                import('@/views/mci/report/salesReport/EventReport.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/report/cashier_report',
      name: 'Báo cáo thu ngân',
      meta: {
        title: 'Báo cáo thu ngân'
      },
      redirect: '/report/cashier_report/invoice_report',
      component: () => import('@/views/nested/menu1/index'),
      children: [
        {
          path: 'refund_report',
          name: 'Báo cáo hoàn tiền',
          meta: {
            title: 'Báo cáo hoàn tiền',
            icon: ''
          },
          component: () => import('@/views/mci/report/refundReport.vue')
        },
        {
          path: 'invoice_report',
          name: 'Báo cáo hóa đơn',
          meta: {
            title: 'Báo cáo hóa đơn',
            icon: ''
          },
          component: () => import('@/views/mci/report/InvoiceReport.vue')
        },
        {
          path: 'take_money_by_invoice_report',
          name: 'Báo cáo thu tiền theo hóa đơn',
          meta: {
            title: 'Báo cáo thu tiền theo hóa đơn',
            icon: ''
          },
          component: () => import('@/views/mci/report/takeMoneybyInvoice.vue')
        },
        {
          path: 'daily_transaction_synthesis_report',
          name: 'Báo cáo tổng hợp giao dịch theo ngày',
          meta: {
            title: 'Báo cáo tổng hợp giao dịch theo ngày',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/dailyTransSynthesisReport/index.vue')
        },
        {
          path: 'cancel_transaction_report',
          name: 'Báo cáo hủy giao dịch',
          meta: {
            title: 'Báo cáo hủy giao dịch',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/cancelTransactionReport.vue')
        },
        {
          path: 'deposit_daily_report',
          name: 'Báo cáo đặt cọc theo ngày',
          meta: {
            title: 'Báo cáo đặt cọc theo ngày',
            icon: ''
          },
          component: () => import('@/views/mci/report/depositDailyReport.vue')
        },
        {
          path: 'mini_bar_report',
          name: 'Báo cáo mini bar',
          meta: {
            title: 'Báo cáo mini bar',
            icon: ''
          },
          component: () => import('@/views/mci/report/miniBarReport.vue')
        },
        {
          path: 'bonus_transaction_report',
          name: 'Báo cáo chi tiết theo đặt phòng',
          meta: {
            title: 'Báo cáo chi tiết theo đặt phòng',
            icon: ''
          },
          component: () =>
            import('@/views/mci/report/incurredTransactionReport.vue')
        },
        {
          path: 'payment_report',
          name: 'Báo cáo thanh toán',
          meta: {
            title: 'Báo cáo thanh toán',
            icon: ''
          },
          component: () => import('@/views/mci/report/paymentReport/index.vue')
        }
      ]
    }
  ]
}
export default reportRouter
